import { LineDashedHorizontalIcon } from '@/components/icons/svgs';

import { cn } from '@/lib/utils';

import { MCP_CAPABILITY_GROUPS } from '../../constants/mcp-content';
import { SECTION_CLASS, SECTION_HEADING_CLASS } from '../../constants/section-classes';

const MCP_CAPABILITIES_SECTION_ID = 'what-it-can-do';

export const McpCapabilitiesSection = () => {
	return (
		<section
			id={MCP_CAPABILITIES_SECTION_ID}
			className={cn(SECTION_CLASS, 'scroll-mt-24')}
		>
			<h2 className={SECTION_HEADING_CLASS}>Try asking your AI</h2>

			<div className="mx-auto mt-10 flex max-w-3xl flex-col gap-8 md:mt-12 md:gap-10">
				{MCP_CAPABILITY_GROUPS.map((group) => (
					<div
						key={group.name}
						className="flex flex-col"
					>
						<h3 className="text-sm font-medium text-secondary md:text-base">{group.name}</h3>
						<div>
							{group.prompts.map((prompt, index) => (
								<div key={prompt}>
									<p className="py-3 text-base font-medium leading-relaxed text-primary md:py-3.5 md:text-lg">
										{`"${prompt}"`}
									</p>
									{index < group.prompts.length - 1 ? (
										<div className="w-full overflow-hidden">
											<LineDashedHorizontalIcon />
										</div>
									) : null}
								</div>
							))}
						</div>
					</div>
				))}
			</div>
		</section>
	);
};
